import AppDashboard from '@/app/pages/Dashboard/AppDashboard.vue'
import AppAttendance from '@/app/pages/Attendance/AppAttendance.vue'
import AppProfile from '@/app/pages/Profile/AppProfile.vue'
import AppClaim from '@/app/pages/Claim/AppClaim.vue'
import AppStartJob from '@/app/pages/Task/AppStartJob.vue'
import AppTaskSelfie from '@/app/pages/Task/AppTaskSelfie.vue'
import AppTaskMeeting from '@/app/pages/Task/AppTaskMeeting.vue'
import AppTaskQuestionnaire from '@/app/pages/Task/AppTaskQuestionnaire.vue'
import AppTaskAudio from '@/app/pages/Task/AppTaskAudio.vue'
import AppTaskCompleted from '@/app/pages/Task/AppTaskCompleted.vue'
import AppTaskCreate from '@/app/pages/Task/AppTaskCreate.vue'

const appRoutes = [
  {
    path: '/app/dashboard',
    name: 'AppDashboard',
    component: AppDashboard,
    meta: { layout: 'AppLayout', private: true, portal: 'app', roleScope: 'employee' }
  },
  {
    path: '/app/task/create',
    name: 'AppTaskCreate',
    component: AppTaskCreate,
    meta: { layout: 'AppLayout', private: true, portal: 'app', roleScope: 'employee' }
  },
  {
    path: '/app/attendance',
    name: 'AppAttendance',
    component: AppAttendance,
    meta: { layout: 'AppLayout', private: true, portal: 'app', roleScope: 'employee' }
  },
  {
    path: '/app/claim',
    name: 'AppClaim',
    component: AppClaim,
    meta: { layout: 'AppLayout', private: true, portal: 'app', roleScope: 'employee' }
  },
  {
    path: '/app/profile',
    name: 'AppProfile',
    component: AppProfile,
    meta: { layout: 'AppLayout', private: true, portal: 'app', roleScope: 'employee' }
  },
  {
    path: '/app/task/:taskId/start',
    name: 'AppStartJob',
    component: AppStartJob,
    meta: { layout: 'AppLayout', private: true, portal: 'app', roleScope: 'employee' }
  },
  {
    path: '/app/task/:taskId/selfie',
    name: 'AppTaskSelfie',
    component: AppTaskSelfie,
    meta: { layout: 'AppLayout', private: true, portal: 'app', roleScope: 'employee' }
  },
  {
    path: '/app/task/:taskId/questionnaire',
    name: 'AppTaskQuestionnaire',
    component: AppTaskQuestionnaire,
    meta: { layout: 'AppLayout', private: true, portal: 'app', roleScope: 'employee' }
  },
  {
    path: '/app/task/:taskId/audio',
    name: 'AppTaskAudio',
    component: AppTaskAudio,
    meta: { layout: 'AppLayout', private: true, portal: 'app', roleScope: 'employee' }
  },
  {
    path: '/app/task/:taskId/meeting',
    name: 'AppTaskMeeting',
    component: AppTaskMeeting,
    meta: { layout: 'AppLayout', private: true, portal: 'app', roleScope: 'employee' }
  },
  {
    path: '/app/task/:taskId/completed',
    name: 'AppTaskCompleted',
    component: AppTaskCompleted,
    meta: { layout: 'AppLayout', private: true, portal: 'app', roleScope: 'employee' }
  }
]

export default appRoutes
